/**
 * 腾讯域：广告操作开关 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.tencent.dtos.ad_operate_switch 对齐。
 *   - GET /api/v1/tencent/ad-operate-switch  → 读开关当前态（任意登录用户可读）
 *   - PUT /api/v1/tencent/ad-operate-switch  → 切换开关（仅 devinzhang / admin，否则后端 403）
 */

import { request } from "../apiClient";

/** 广告操作开关当前态（与后端 AdOperateSwitchRecord 对齐）。 */
export interface AdOperateSwitchRecord {
  switch_key: string;
  is_on: boolean;
  create_user?: string | null;
  modify_user?: string | null;
  created_time?: string | null;
  updated_time?: string | null;
}

export interface SaveAdOperateSwitchBody {
  is_on: boolean;
}

/** 读取广告操作开关当前态；表无行时后端返回默认态 is_on=true。 */
export async function getAdOperateSwitch(): Promise<AdOperateSwitchRecord | null> {
  return request<AdOperateSwitchRecord | null>(
    "/api/v1/tencent/ad-operate-switch",
  );
}

/** 切换广告操作开关；返回切换后当前态（含更新后的审计列）。非白名单用户后端返回 403。 */
export async function saveAdOperateSwitch(
  body: SaveAdOperateSwitchBody,
): Promise<AdOperateSwitchRecord> {
  return request<AdOperateSwitchRecord>("/api/v1/tencent/ad-operate-switch", {
    method: "PUT",
    body,
  });
}
